// Centralized layout settings management
import { currentUserId } from './meta';

export const AGENT_CHAT_MODES = {
  COLLAPSED: 'collapsed',
  EXPANDED: 'expanded',
  PINNED: 'pinned',
};

export const SIDEBAR_LAYOUT_BOUNDS = {
  initialWidth: 320,
  minWidth: 256,
  maxWidth: 384,
};

export const AGENT_CHAT_LAYOUT_BOUNDS = {
  initialWidth: 320,
  minWidth: 320,
  maxWidth: 600,
};

export const WIDGETS_LAYOUT_BOUNDS = {
  // Pane = 328px widget card (w-82 in shared/Widget) + the views' 12px p-3 gutters on each side.
  initialWidth: 352,
  minWidth: 256,
  maxWidth: 480,
};

// The rail uses the same resize affordance as widgets but keeps its own initial width.
// Dragging below minWidth snaps to condensedWidth: avatar-only rows (12px gutter +
// 14px row padding + 48px flexicon + 14px) with the rail toggle hidden.
export const WORKSPACE_RAIL_LAYOUT_BOUNDS = {
  initialWidth: 320,
  minWidth: 256,
  maxWidth: 480,
  condensedWidth: 100,
};

export const WIDGET_BUILDER_PREVIEW_LAYOUT_BOUNDS = {
  initialWidth: 384,
  minWidth: 256,
  maxWidth: 480,
};

export const CONTENT_SIDEBAR_LAYOUT_BOUNDS = {
  initialWidth: 240,
  minWidth: 180,
  maxWidth: 400,
};

export const DEFAULT_LAYOUT_SETTINGS = {
  agentChatMode: AGENT_CHAT_MODES.COLLAPSED,
  sidebarWidth: SIDEBAR_LAYOUT_BOUNDS.initialWidth,
  agentChatWidth: AGENT_CHAT_LAYOUT_BOUNDS.initialWidth,
  composerToolbarVisible: false,
  widgetsOpen: true,
  widgetsWidth: WIDGETS_LAYOUT_BOUNDS.initialWidth,
  workspaceRailWidth: WORKSPACE_RAIL_LAYOUT_BOUNDS.initialWidth,
  widgetBuilderPreviewWidth: WIDGET_BUILDER_PREVIEW_LAYOUT_BOUNDS.initialWidth,
  contentSidebarWidth: CONTENT_SIDEBAR_LAYOUT_BOUNDS.initialWidth,
  threadListVisible: true,
};

// v2 is user-scoped rather than profile-scoped.
const LAYOUT_SETTINGS_KEY = 'output:layoutSettings:v2';

const getLayoutSettingsStorageKey = () => {
  return `${LAYOUT_SETTINGS_KEY}:${currentUserId() || 'anon'}`;
};

// Load all layout settings from localStorage
export const loadLayoutSettings = () => {
  try {
    const stored = localStorage.getItem(getLayoutSettingsStorageKey());
    if (stored) {
      const parsed = JSON.parse(stored);
      // Merge with defaults to handle missing keys
      return { ...DEFAULT_LAYOUT_SETTINGS, ...parsed };
    }
  } catch {
    // nnop, fall through to defaults
  }
  return { ...DEFAULT_LAYOUT_SETTINGS };
};

export const saveLayoutSettings = (settings) => {
  try {
    localStorage.setItem(getLayoutSettingsStorageKey(), JSON.stringify(settings));
  } catch {
    // noop, localStorage might be disabled
  }
};

export const isValidAgentChatMode = (mode) => {
  return Object.values(AGENT_CHAT_MODES).includes(mode);
};
